/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
import {getAuth } from "firebase/auth"
import { httpsCallable, getFunctions } from "firebase/functions";
import './Landing.css'
// reactstrap ../../components
import {
//  Badge,
  Button,
  Card,
  CardBody,
//  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

// core ../../components
import DemoNavbar from "../../components/Navbars/DemoNavbar.js";
import CardsFooter from "../../components/Footers/CardsFooter.js";
import axios from 'axios'; // Import Axios for making HTTP requests
import { Link } from "react-router-dom";

// index page sections
//import Download from "../IndexSections/Download.js";

/* Top Co Cfg */
import hostingCfg from "../../hostingcfg/hostingcfg.json"
/*  ---- Move to Components later --------- */
const REACT_APP_PRJQUERY_BEPY_URL = process.env.REACT_APP_PRJQUERY_BEPY_URL
const functions = getFunctions();

/* Service list in one place */
const ServiceList = () => {
  return (
       <p className="display-5 text-white" style={{ fontSize: '16px', paddingTop: '8px' }}>
  The design system comes with full support for product development end to end.  
        <h3 className="text-white mt-4">We offer:</h3>
        <ul className="text-white">
          <li><a href="/mgmtServices-page" className="text-white">Management Consultancy (Learn More <span aria-hidden="true">↗)</span></a></li>
          <li><a href="/SiEngConsult-page" className="text-white">System on Chip Lifecycle Services (Learn More <span aria-hidden="true">↗)</span></a></li>
          <li><a href="/FWLinuxServices-page" className="text-white">Embedded/Firmware Development (Learn More <span aria-hidden="true">↗)</span></a></li>
          <li><a href="/AIMLDS-page" className="text-white">AI and Data Analysis Services (Learn More <span aria-hidden="true">↗)</span></a></li>
        </ul>
      </p>
  );
};

class Landing extends React.Component {
  state = {
    name: '',
    email: '',
    message: '',
    nameFocused: false,
    emailFocused: false
  };
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, message } = this.state;
    const auth = getAuth();
    console.log('Auth = ', {auth})
    if(auth && auth.currentUser)
    {
        //console.log('currentUser = ', {auth.currentUser})
        try {
            console.log('Response from BE:', name, email, message);
            //console.log("project url ",REACT_APP_PRJQUERY_BEPY_URL)
    /*      const response = await axios.post('https://your-backend-api-url.com/userData', {
            name,
            email,
            message
          }); */
          //console.log('Response from BE:', response.data);
          // Optionally handle success or navigate to another page
        } catch (error) {
          console.error('Error sending data:', error);
          // Optionally handle error
        }
   /*  ---- Move to Components later --------- */
    // Call Cloud Function to process the file
    const projectQuery = httpsCallable(functions, 'projectQuery', { method: 'POST' });
    const data = { name: name, email: email, message:message };
    
    projectQuery(data)
      .then((result) => {
        console.log('Project Query result=', { result });
        if (result.data.success === true) {
          //setProcessSuccess(true);
        } else {
          alert('Failed to process message');
        }
        // setProcessedFileUrl(result.data.download_link);
      })
      .catch((error) => {
        console.error('Error processing message:', error);
        if (error.error === 'Failed to process Message') {
          alert('Failed to process Message');
        } else {
          alert('An unexpected error occurred.');
        }
      })
      .finally(() => {
        
      });
    /*  ---- Move to Components later --------- */    
    }
    else
        alert('You are not signed in to send Information ');
  };

  
  render() {
    const company = hostingCfg.Company;
    const CoreTeam = hostingCfg.CoreTeam;
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-0" >
              <div className="shape shape-style-1 shape-default " >
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>

              <Container fluid className="py-0 d-flex"> {/* Use fluid to fill the entire width */}
              <Row className="row-grid align-items-center"> {/* Align items as needed */}
                <Col xl="7" lg="7" md="8" sm="12" className="text-left"> {/* Ensure left alignment */}
                 <h1 className="display-3 text-white">
                        {company.name}
                        <span>Connected with leading technology players</span>
                      </h1>
                      <ServiceList />

                    </Col>

                <Col className="order-lg-2 text-center" sm="12" md="4" lg="5" xl="5">
                  <div className="card-profile-image">                    
                          <img
                            alt="..."
                            src={require("../../assets/img/theme/Designer_2.jpeg")}
                            className="img-fluid" // Make image responsive
                            style={{ maxHeight: "100%", width: "auto" }}                             
                          /> 
                      </div>
                    </Col>
                  </Row>
              </Container>

            </section>
            {/* 1st Hero Variation */}
          </div>

          <section className="section section-lg" >
            <Container>
              <Row className="justify-content-center text-center mb-lg" >
                <Col lg="8">
                  <h2 className="display-3">The amazing Team</h2>
                  <p className="lead text-muted">
                    {/* Fill Some words here */}
                  </p>
                </Col>
              </Row>
              <Row className="align-items-stretch">
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4" >
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("../../assets/img/theme/team-1-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">{CoreTeam[3].Name}   </span>
                        <small className="h6 text-muted"> {CoreTeam[3].Role} </small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="warning"
                          href={CoreTeam[3].twitterHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="warning"
                          href={CoreTeam[3].fbHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="warning"
                          href={CoreTeam[3].drbltHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("../../assets/img/theme/team-1-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">{CoreTeam[2].Name}</span>
                        <small className="h6 text-muted">
                          {CoreTeam[2].Role}
                        </small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="primary"
                          href={CoreTeam[2].twitterHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="primary"
                          href={CoreTeam[2].fbHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="primary"
                          href={CoreTeam[2].drbltHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("../../assets/img/theme/team-1-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1"> {CoreTeam[1].Name} </span>
                        <small className="h6 text-muted"> {CoreTeam[1].Role} </small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="info"
                          href={CoreTeam[1].twitterHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="info"
                          href={CoreTeam[1].fbHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="info"
                          href={CoreTeam[1].drbltHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("../../assets/img/theme/team-2-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1"> Deepti</span>
                        <small className="h6 text-muted">Founder </small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="success"
                          href={CoreTeam[0].twitterHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="success"
                          href={CoreTeam[0].fbHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="success"
                          href={CoreTeam[0].drbltHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
                <Row> </Row>
                <Row> </Row>                
              <Row className="align-items-stretch">
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4" >
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("../../assets/img/theme/team-1-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">{CoreTeam[4].Name}   </span>
                        <small className="h6 text-muted"> {CoreTeam[4].Role} </small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="warning"
                          href={CoreTeam[4].twitterHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="warning"
                          href={CoreTeam[4].fbHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="warning"
                          href={CoreTeam[4].drbltHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("../../assets/img/theme/team-1-800x800.jpg")}
                      style={{ width: "200px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">{CoreTeam[5].Name}</span>
                        <small className="h6 text-muted">
                          {CoreTeam[5].Role}
                        </small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="primary"
                          href={CoreTeam[5].twitterHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="primary"
                          href={CoreTeam[5].fbHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-facebook" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="primary"
                          href={CoreTeam[5].drbltHdl}
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-dribbble" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg pt-0">
  
          </section>
          <section className="section section-lg bg-gradient-default">
            <Container className="pt-lg pb-300">
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Our Strengths </h2>
                  <p className="lead text-white">
                    .....
                  </p>
                </Col>
              </Row>
              <Row className="row-grid mt-5">
                <Col lg="4">
                  <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                    <i className="ni ni-settings text-primary" />
                  </div>
                  <h5 className="text-white mt-3">Building together</h5>
                  <p className="text-white mt-3">
                    Uniting Vision, Creating Impact.
                  </p>
                </Col>
                <Col lg="4">
                  <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                    <i className="ni ni-ruler-pencil text-primary" />
                  </div>
                  <h5 className="text-white mt-3">Growth Mindset </h5>
                  <p className="text-white mt-3">
                    Embracing Challenges, Fueling Innovation.
                  </p>
                </Col>
                <Col lg="4">
                  <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                    <i className="ni ni-atom text-primary" />
                  </div>
                  <h5 className="text-white mt-3">Fast Launch time</h5>
                  <p className="text-white mt-3">
                    We have track of one of fastest launches.
                  </p>
                </Col>
              </Row>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
          <section className="section section-lg pt-lg-0 section-contact-us">
            <Container>
              <Row className="justify-content-center mt--300">
                <Col lg="8">
                  <Card className="bg-gradient-secondary shadow">
                    <CardBody className="p-lg-5">
                      <h4 className="mb-1">Looking reliable partner for your project, Look no further </h4>
                      <p className="mt-0">Your project is very important to us. Share your requirement/contact (Accepted from Signed-In users only) </p>
                      <form onSubmit={this.handleSubmit}>
                        <FormGroup className={classnames("mt-5", { focused: this.state.nameFocused })}>
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-user-run" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Your name"
                              type="text"
                              name="name"
                              value={this.state.name}
                              onFocus={() => this.setState({ nameFocused: true })}
                              onBlur={() => this.setState({ nameFocused: false })}
                              onChange={this.handleChange}
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup className={classnames({ focused: this.state.emailFocused })}>
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-email-83" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Email address"
                              type="email"
                              name="email"
                              value={this.state.email}
                              onFocus={() => this.setState({ emailFocused: true })}
                              onBlur={() => this.setState({ emailFocused: false })}
                              onChange={this.handleChange}
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup className="mb-4">
                          <Input
                            className="form-control-alternative"
                            cols="180"
                            name="message"
                            placeholder="Type a message..."
                            type="textarea"
                            value={this.state.message}
                            onChange={this.handleChange}
                            rows="4"
                          />
                        </FormGroup>
                        <Button
                          block
                          className="btn-round"
                          color="default"
                          size="lg"
                          type="submit"
                        >
                          Send Message
                        </Button>
                      </form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <CardsFooter />
      </>
    );
  }
}
export default Landing;
